<template>
  <div class="form-page">

    <!-- HEADER -->
    <div class="form-header">
      <h2 class="form-title">
        {{ $route.path.includes('/create') ? $t("Yangi filial") : $t("Filialni tahrirlash") }}
      </h2>
      <div class="header-actions">
        <button type="button" class="save-btn" @click="Savedokument()">
          <b-icon icon="check-circle-fill"></b-icon>
          {{ $t("Saqlash va yopish") }} <small>Ctrl+Enter</small>
        </button>
        <router-link :to="{ path: '/malumot/sklad/index' }">
          <button type="button" class="close-btn">
            <b-icon icon="x-circle"></b-icon>
            {{ $t("Chiqish") }} <small>Esc</small>
          </button>
        </router-link>
      </div>
    </div>

    <!-- FILIAL MA'LUMOTLARI -->
    <div class="form-card">
      <div class="fields-grid">

        <div class="field-row" v-if="!$route.path.includes('/create')">
          <label class="field-label">SMS kod</label>
          <input class="modern-input" ref="focused" v-model="datas.sms_code" type="text" placeholder="SMS kod..." />
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Nomi") }}</label>
          <input class="modern-input" v-model="datas.name" type="text" :placeholder="$t('Nomi...')" />
        </div>

        <div class="field-row">
          <label class="field-label">Telefon</label>
          <input class="modern-input" v-model="datas.phone_number" type="text" placeholder="+998..." />
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Manzil") }}</label>
          <input class="modern-input" v-model="datas.address" type="text" :placeholder="$t('Manzil...')" />
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Chek izohi") }}</label>
          <input class="modern-input" v-model="datas.check_word" type="text" :placeholder="$t('Chek izohi...')" />
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Foyda turi") }}</label>
          <div class="select-wrap">
            <v-select
              :clearable="false"
              :options="commontypelist"
              v-model="datas.common_price_type"
              :reduce="n => n.id"
              label="name"
            ></v-select>
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Chakana narx") }}</label>
          <div class="select-wrap">
            <v-select
              :clearable="false"
              :options="pricetypelist"
              v-model="datas.chakana_price_type"
              :reduce="n => n.id"
              label="name"
            ></v-select>
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Optom narx") }}</label>
          <div class="select-wrap">
            <v-select
              :clearable="false"
              :options="pricetypelist"
              v-model="datas.optom_price_type"
              :reduce="n => n.id"
              label="name"
            ></v-select>
          </div>
        </div>

        <div class="field-row">
          <label class="field-label">{{ $t("Parol") }}</label>
          <input class="modern-input" v-model="datas.update_password" type="password" placeholder="••••••••" />
        </div>

      </div>
    </div>

    <!-- PRINTER SOZLAMALARI -->
    <div class="section-title">
      <b-icon icon="printer-fill"></b-icon>
      {{ $t("Printer sozlamalari") }}
    </div>

    <div class="alert-box" v-if="printerAlert">
      <b-icon icon="check-circle-fill"></b-icon>
      {{ $t(printerAlert) }}
    </div>

    <div class="printer-grid">

      <!-- Printerlar -->
      <div class="form-card">
        <div class="card-section-title">
          <b-icon icon="printer" style="color:#a142f4"></b-icon>
          {{ $t("Printerlar") }}
        </div>
        <div class="fields-grid">
          <div class="field-row">
            <label class="field-label">{{ $t("Asosiy printer") }}</label>
            <input class="modern-input" v-model="printerSettings.printer_name" type="text" placeholder="Printer nomi..." />
          </div>
          <div class="field-row">
            <label class="field-label">{{ $t("Chek printer") }}</label>
            <input class="modern-input" v-model="printerSettings.check_printer_name" type="text" placeholder="Printer nomi..." />
          </div>
        </div>
      </div>

      <!-- Firma ma'lumotlari -->
      <div class="form-card">
        <div class="card-section-title">
          <b-icon icon="building" style="color:#a142f4"></b-icon>
          {{ $t("Firma ma'lumotlari") }}
        </div>
        <div class="fields-grid">
          <div class="field-row">
            <label class="field-label">{{ $t("Firma nomi") }}</label>
            <input class="modern-input" v-model="printerSettings.sender.firm_name" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">{{ $t("Manzil") }}</label>
            <input class="modern-input" v-model="printerSettings.sender.address" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">Р/С</label>
            <input class="modern-input" v-model="printerSettings.sender.p_c" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">МФО</label>
            <input class="modern-input" v-model="printerSettings.sender.mfo" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">ОКЕД</label>
            <input class="modern-input" v-model="printerSettings.sender.oked" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">ИНН</label>
            <input class="modern-input" v-model="printerSettings.sender.inn" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">Директор</label>
            <input class="modern-input" v-model="printerSettings.sender.director" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">QR код</label>
            <input class="modern-input" v-model="printerSettings.qrcode" type="text" />
          </div>
          <div class="field-row">
            <label class="field-label">Logotip</label>
            <div class="logo-section">
              <input type="file" style="display:none" id="logo-file" ref="logoFile" @change="UploadLogo()" />
              <button type="button" class="upload-btn" @click="$refs.logoFile.click()">
                <b-icon icon="cloud-arrow-up-fill"></b-icon>
                {{ $t("Yuklash") }}
              </button>
              <div class="logo-preview" v-if="printerSettings.file_name">
                <img :src="axios.defaults.baseURL + 'api/v1/uploads/' + printerSettings.file_name" class="logo-img" />
                <button type="button" class="del-logo-btn" @click="DeleteLogo()">
                  <b-icon icon="trash-fill"></b-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { print } from "../../../components/mixins/print.js";
export default {
  mixins: [print],
  name: "sklad-form",
  props: ["datas"],
  data() {
    return {
      commontypelist: [
        { id: 1, name: "So'm" },
        { id: 2, name: "Dollar" }
      ],
      pricetypelist: [
        { id: 1, name: "So'm" },
        { id: 2, name: "Dollar" },
        { id: 3, name: "Dollar va So'm" }
      ],
      printerSettings: {
        printer_name: "",
        check_printer_name: "",
        qrcode: "",
        file_name: null,
        sender: {
          firm_name: "",
          address: "",
          p_c: "",
          mfo: "",
          oked: "",
          inn: "",
          director: ""
        }
      },
      printerAlert: ""
    };
  },
  created() {
    this.$root.$refs.sklad = this;
  },
  mounted() {
    this.Focus();
    this.LoadPrinterSettings();
  },
  methods: {
    Focus() {
      this.$nextTick(() => {
        if (this.$refs.focused) this.$refs.focused.focus();
      });
    },
    LoadPrinterSettings() {
      axios.post("api/v1/sklad-settings", {
        sklad_id: localStorage.getItem('sklad_id'),
        key: 'a4_printer'
      }).then(res => {
        if (res.data.data != null) {
          const loaded = JSON.parse(res.data.data);
          this.printerSettings = Object.assign({
            printer_name: "",
            check_printer_name: "",
            qrcode: "",
            file_name: null,
            sender: { firm_name: "", address: "", p_c: "", mfo: "", oked: "", inn: "", director: "" }
          }, loaded);
          if (!this.printerSettings.sender) {
            this.printerSettings.sender = { firm_name: "", address: "", p_c: "", mfo: "", oked: "", inn: "", director: "" };
          }
        }
      });
    },
    SavePrinterSettings() {
      return axios.patch("api/v1/sklad-settings", {
        sklad_id: localStorage.getItem('sklad_id'),
        key: 'a4_printer',
        data: JSON.stringify(this.printerSettings)
      }).then(res => {
        if (res.data.data != null) {
          this.printerAlert = "Ma'lumotlar saqlandi!";
          setTimeout(() => { this.printerAlert = ''; }, 3000);
        }
      });
    },
    UploadLogo() {
      const formData = new FormData();
      formData.append("file_name", this.$refs.logoFile.files[0]);
      axios.post("api/v1/upload/image", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(res => {
        this.printerSettings.file_name = res.data.file_name;
      });
    },
    DeleteLogo() {
      axios.post("api/v1/upload/delete-image", { file_name: this.printerSettings.file_name }).then(res => {
        if (res.data.message) {
          this.printerSettings.file_name = null;
          this.$bvToast.toast(this.$t("Rasm o'chirildi"), {
            variant: 'success',
            toaster: 'b-toaster-bottom-center'
          });
        }
      });
    },
    Savedokument() {
      if (!this.rule.change) {
        this.$store.state.errors = this.$t('Sizdan bunday xuquq mavjud emas');
        return;
      }
      const isCreate = this.$route.path === "/malumot/sklad/create";
      const method = isCreate ? "post" : "patch";
      const url = isCreate ? "api/v1/sklads" : `api/v1/sklads/id/${this.$route.params.id}`;
      axios({ method, url, data: this.datas }).then(() => {
        this.SavePrinterSettings().then(() => {
          this.$store.state.saved = 1;
          this.$router.push({ name: "Склад" });
        });
      });
    }
  }
};
</script>

<style scoped>
.form-page {
  padding: 24px;
  background: #f8fafc;
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.form-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.save-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 42px;
  padding: 0 22px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}
.close-btn {
  background: white;
  color: #64748b;
  border: 1px solid #e2e8f0;
  height: 42px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 28px 0 16px;
}
.printer-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.form-card {
  background: white;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  margin-bottom: 20px;
}
.card-section-title {
  font-weight: 800;
  font-size: 15px;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 16px;
}
.fields-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.field-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  gap: 20px;
}
.field-label {
  font-weight: 600;
  color: #64748b;
  font-size: 14px;
  margin: 0;
  text-align: right;
}
.modern-input {
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 16px;
  font-size: 14px;
  color: #2d3748;
  width: 100%;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.modern-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}
.select-wrap {
  width: 100%;
}
.select-wrap /deep/ .vs__dropdown-toggle {
  min-height: 44px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 4px 8px;
}
.select-wrap /deep/ .vs__dropdown-toggle:focus-within {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.1);
}
.alert-box {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 12px 18px;
  color: #16a34a;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.upload-btn {
  background: rgba(161, 66, 244, 0.08);
  color: #a142f4;
  border: 1px solid rgba(161, 66, 244, 0.2);
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.logo-preview {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.del-logo-btn {
  background: #fff1f2;
  color: #e11d48;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
